module.exports = __webpack_public_path__ + "assets\\img\\icons\\favicon-16x16.png?963ca284ae4e8ba3f489";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/favicon-16x16.png
// module id = 151
// module chunks = 0